var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackgroundDecorator(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1284 441",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "decorator") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Landing",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD",
    transform: "translate(2.000000, -478.000000)",
    stroke: "#D9D9D9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "decorator",
    transform: "translate(-0.500000, 478.692422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,125.807578 C82.341324,245.00811 162.838991,304.608375 241.493,304.608375 C357.745223,304.608375 436.168284,125.807578 565.372147,46.9274593 C921.710975,-170.620595 1281.01002,438.807578 1281.01002,438.807578",
    id: "Line"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,125.807578 C56.3333333,241.463462 129.833333,310.485529 220.5,332.873779 C356.5,366.456153 453.642931,129.903749 579.289061,50.4157046 C883.74322,-142.192422 1281.01002,438.807578 1281.01002,438.807578",
    id: "Line"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundDecorator);
export default __webpack_public_path__ + "static/media/background_decorator.79eec3380e346c5a3c8a215def684cf8.svg";
export { ForwardRef as ReactComponent };